import axios from "axios";

export default {
  namespaced: true,
  state: {
    general: {
      firstStepOrNot: false,
      info: {
        title: "",
        description: "",
        studyDisciplineName: "",
      },
      virtualPatient: {
        diaTestId: null,
        patientId: null,
        episodeId: null,
        isLabTakeOrder: false,
        isInstrumentalTakeOrder: false,
      },
      arrayActive: [
        { id: 1, name: "Сбор жалоб", view: false, success: false },
        { id: 2, name: "Сбор анамнеза", view: false, success: false },
        { id: 3, name: "Осмотр", view: false, success: false },
        { id: 4, name: "Пальпация", view: false, success: false },
        { id: 5, name: "Перкуссия", view: false, success: false },
        { id: 6, name: "Аускультация", view: false, success: false },
        {
          id: 7,
          name: "Постановка синдромального диагноза",
          view: false,
          success: false,
        },
        {
          id: 8,
          name: "Постановка предварительного диагноза",
          view: false,
          success: false,
        },
        {
          id: 9,
          name: "Назначение лабораторных исследований",
          view: false,
          success: false,
        },
        {
          id: 10,
          name: "Назначение инструментальных исследований",
          view: false,
          success: false,
        },
        {
          id: 11,
          name: "Постановка окончательного диагноза",
          view: false,
          success: false,
        },
      ],
      currentLevel: 0,
      iconsList: [
        {
          icon: "ds.svg",
          name: "ДС",
          nameLong: "Дыхательная система",
          id: "f99c9578-50ac-48b5-b94d-037cd8520304",
          loading: false,
          localStatus: "",
        },
        {
          icon: "ls.svg",
          name: "ЛС",
          nameLong: "Лимфатическая система",
          id: "c92c1881-5140-4cfc-9f55-a0c5f2cdc24d",
          loading: false,
          localStatus: "",
        },
        {
          icon: "ms.svg",
          name: "МС",
          nameLong: "Мочевая система",
          id: "ccca1011-8716-428a-95d5-3c7fca0d1b32",
          loading: false,
          localStatus: "",
        },
        {
          icon: "ns.svg",
          name: "НС",
          nameLong: "Нервная система",
          id: "8bbe6ce8-7234-428b-9350-b871e63bc378",
          loading: false,
          localStatus: "",
        },
        {
          icon: "oda.svg",
          name: "КМС",
          nameLong: "Костно-мышечная система",
          id: "c4f8d32b-8cfe-44da-9228-4938291693e5",
          loading: false,
          localStatus: "",
        },
        {
          icon: "ps.svg",
          name: "ПищС",
          nameLong: "Пищеварительная система",
          id: "b9003edc-c4ce-4d3b-afce-7db04f9c9fec",
          loading: false,
          localStatus: "",
        },
        {
          icon: "poks.svg",
          name: "ПС",
          nameLong: "Покровная система",
          id: "c7ab1583-f64e-4d1b-adc8-737178a04f15",
          loading: false,
          localStatus: "",
        },
        {
          icon: "rs.svg",
          name: "РС",
          nameLong: "Репродуктивная система",
          id: "9471c8ad-5c1f-4c0b-ae5a-3fdd9cd5e08e",
          loading: false,
          localStatus: "",
        },
        {
          icon: "ss.svg",
          name: "СС",
          nameLong: "Сенсорная система",
          id: "5b0dd881-6ede-4d62-b349-ef81b57024c4",
          loading: false,
          localStatus: "",
        },
        {
          icon: "sss.svg",
          name: "ССС",
          nameLong: "Сердечно-сосудистая система",
          id: "033a35c0-2d7f-4039-a0e1-5685e5f57c72",
          loading: false,
          localStatus: "",
        },
        {
          icon: "es.svg",
          name: "ЭС",
          nameLong: "Эндокринная система",
          id: "bfc31163-9143-42e2-b527-0fb8fac3b9c6",
          loading: false,
          localStatus: "",
        },
      ],
      timer: null,
    },
    choice: {
      array: [
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000001",
          name: "Сбор жалоб",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "complaints.svg",
          iconGif: "complaints.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000002",
          name: "Сбор анамнеза",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "anamnez.svg",
          iconGif: "anamnez.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000003",
          name: "Осмотр",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "inspection.svg",
          iconGif: "inspection.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000004",
          name: "Пальпация",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "palpation.svg",
          iconGif: "palpation.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000005",
          name: "Перкуссия",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "perkusion.svg",
          iconGif: "perkusion.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000006",
          name: "Аускультация",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "auskultation.svg",
          iconGif: "auskultation.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000007",
          name: "Постановка синдромального диагноза",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "preliminaryDiagnosis.svg",
          iconGif: "preliminaryDiagnosis.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000008",
          name: "Постановка предварительного диагноза",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "preliminaryDiagnosis.svg",
          iconGif: "preliminaryDiagnosis.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000009",
          name: "Назначение лабораторных исследований",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "analys.svg",
          iconGif: "analys.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000010",
          name: "Назначение инструментальных исследований",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "instrumental.svg",
          iconGif: "instrumental.gif",
        },
        {
          id: "",
          sectionId: "00000000-0000-0000-0000-000000000011",
          name: "Постановка окончательного диагноза",
          value: false,
          correct: null,
          visibleType: 1,
          icon: "finalDiagnosis.svg",
          iconGif: "finalDiagnosis.gif",
        },
      ],
      arrayRoute: [
        {
          currentStep: 1,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000001",
          name: "Сбор жалоб",
          route: "complaints",
          visibleType: 1,
        },
        {
          currentStep: 2,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000002",
          name: "Сбор анамнеза",
          route: "anamnesis-diag",
          visibleType: 1,
        },
        {
          currentStep: 3,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000003",
          name: "Осмотр",
          route: "inspection",
          visibleType: 1,
        },
        {
          currentStep: 4,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000004",
          name: "Пальпация",
          route: "palpation",
          visibleType: 1,
        },
        {
          currentStep: 5,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000005",
          name: "Перкуссия",
          route: "perkusion",
          visibleType: 1,
        },
        {
          currentStep: 6,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000006",
          name: "Аускультация",
          route: "auskultation",
          visibleType: 1,
        },
        {
          currentStep: 7,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000007",
          name: "Постановка синдромального диагноза",
          route: "syndromal-diagnosis",
          visibleType: 1,
        },
        {
          currentStep: 8,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000008",
          name: "Постановка предварительного диагноза",
          route: "preliminary-diagnosis",
          visibleType: 1,
        },
        {
          currentStep: 9,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000009",
          name: "Назначение лабораторных исследований",
          route: "laboratory-tests",
          visibleType: 1,
        },
        {
          currentStep: 10,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000010",
          name: "Назначение инструментальных исследований",
          route: "instrumental-tests",
          visibleType: 1,
        },
        {
          currentStep: 11,
          view: false,
          success: false,
          sectionId: "00000000-0000-0000-0000-000000000011",
          name: "Постановка окончательного диагноза",
          route: "final-diagnosis",
          visibleType: 1,
        },
      ],
    },
    complaints: {
      array: [],
    },
    anamnesis: {
      array: [],
    },
    showContainers: false,
    dataSomaticStatusBodySystems: [],
    sprPhysResearch: {
      dialogMedia: false,
      arrayCircles: [
        {
          name: "Голова",
          bodyPartId: "59c86ea0-8c2e-40d6-878c-a8f96e2bfa7f",
          hover: false,
          array: [
            { cx: 100, cy: 18, r: 8, fill: "#33A56E" },
            { cx: 100, cy: 18, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Ухо правое",
          bodyPartId: "555B3272-3535-4928-9D9F-C016FEF6DE9B",
          hover: false,
          array: [
            { cx: 64, cy: 48, r: 8, fill: "#33A56E" },
            { cx: 64, cy: 48, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Ухо левое",
          bodyPartId: "F4E6024F-F131-45C1-B684-42C4342CCB1B",
          hover: false,
          array: [
            { cx: 137, cy: 48, r: 8, fill: "#33A56E" },
            { cx: 137, cy: 48, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Шея",
          bodyPartId: "2feed71b-48c5-478e-81d8-baff20e7c7a1",
          hover: false,
          array: [
            { cx: 100, cy: 102, r: 8, fill: "#33A56E" },
            { cx: 100, cy: 102, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Плечо правое",
          bodyPartId: "954ec204-c4ba-4ca0-80a8-943f83cc2849",
          hover: false,
          array: [
            { cx: 52, cy: 127, r: 8, fill: "#33A56E" },
            { cx: 52, cy: 127, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Предплечье правое",
          bodyPartId: "2a12eb2b-1739-4090-bc49-7aa981ae99c2",
          hover: false,
          array: [
            { cx: 38, cy: 205, r: 8, fill: "#33A56E" },
            { cx: 38, cy: 205, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Кисть правая",
          bodyPartId: "2805551f-766c-4e77-af34-d18583d875d3",
          hover: false,
          array: [
            { cx: 30, cy: 280, r: 8, fill: "#33A56E" },
            { cx: 30, cy: 280, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Кисть левая",
          bodyPartId: "d6f786a0-b617-4cd9-a3c8-0168616c7772",
          hover: false,
          array: [
            { cx: 173, cy: 280, r: 8, fill: "#33A56E" },
            { cx: 173, cy: 280, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Предплечье левое",
          bodyPartId: "90188616-c5e4-4b08-bfaf-baafe1afc2a6",
          hover: false,
          array: [
            { cx: 163, cy: 205, r: 8, fill: "#33A56E" },
            { cx: 163, cy: 205, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Грудная клетка",
          bodyPartId: "0dc3a76a-e655-4909-bc44-9e7c37859b4f",
          hover: false,
          array: [
            { cx: 100, cy: 155, r: 8, fill: "#33A56E" },
            { cx: 100, cy: 155, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Живот",
          bodyPartId: "01276954-9837-41a7-955f-78804a191e88",
          hover: false,
          array: [
            { cx: 100, cy: 225, r: 8, fill: "#33A56E" },
            { cx: 100, cy: 225, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Бедро правое",
          bodyPartId: "465f02ae-eb8b-4755-8ade-cbfa1321bef8",
          hover: false,
          array: [
            { cx: 63, cy: 292, r: 8, fill: "#33A56E" },
            { cx: 63, cy: 292, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Паховая область",
          bodyPartId: "5ca5f3cc-f234-4d79-94cd-96b868a95fd1",
          hover: false,
          array: [
            { cx: 100, cy: 310, r: 8, fill: "#33A56E" },
            { cx: 100, cy: 310, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Бедро левое",
          bodyPartId: "cce88c6e-b990-4ea3-aae5-28880a847d13",
          hover: false,
          array: [
            { cx: 140, cy: 292, r: 8, fill: "#33A56E" },
            { cx: 140, cy: 292, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Голень левая",
          bodyPartId: "2f8c85ba-86c4-4c5a-bcb0-2a5a8c8b476e",
          hover: false,
          array: [
            { cx: 123, cy: 402, r: 8, fill: "#33A56E" },
            { cx: 123, cy: 402, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Левый голеностопный сустав",
          bodyPartId: "939c50fd-9c5b-407b-a960-9f441aadb14c",
          hover: false,
          array: [
            { cx: 118, cy: 490, r: 8, fill: "#33A56E" },
            { cx: 118, cy: 490, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Стопа левая",
          bodyPartId: "e96e52b9-5c81-4b74-975e-322f55ae963e",
          hover: false,
          array: [
            { cx: 118, cy: 514, r: 8, fill: "#33A56E" },
            { cx: 118, cy: 514, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Голень правая",
          bodyPartId: "ef372b9f-394e-4395-b829-321e695dc568",
          hover: false,
          array: [
            { cx: 78, cy: 402, r: 8, fill: "#33A56E" },
            { cx: 78, cy: 402, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Правый голеностопный сустав",
          bodyPartId: "3e1a6de5-225e-4d5a-ab8e-8056d93a0bf6",
          hover: false,
          array: [
            { cx: 84, cy: 490, r: 8, fill: "#33A56E" },
            { cx: 84, cy: 490, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Стопа правая",
          bodyPartId: "9cf9ac57-8e26-498d-a519-6f1293fb5153",
          hover: false,
          array: [
            { cx: 80, cy: 514, r: 8, fill: "#33A56E" },
            { cx: 80, cy: 514, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Плечо левое",
          bodyPartId: "e9688445-d97c-4f6a-b2b1-dd061e9df031",
          hover: false,
          array: [
            { cx: 147, cy: 127, r: 8, fill: "#33A56E" },
            { cx: 147, cy: 127, r: 4, fill: "white" },
          ],
          files: [],
        },
      ],
      selectedCircle: {
        index: null,
        bodyPartId: null,
        files: [],
        name: "",
      },
      currentObj: null,
      groups: [],
    },
    diagnosis: {
      mkb: [],
      array: [],
      patalogy: [],
    },
    labTest: {
      group: [],
    },
    instrTest: {
      group: [],
    },
  },
  getters: {
    getSections(state) {
      for (let i = 0; i < state.choice.array.length; i++) {
        for (let j = 0; j < state.choice.arrayRoute.length; j++) {
          if (state.choice.arrayRoute[j].success) {
            if (
              state.choice.array[i].sectionId ===
              state.choice.arrayRoute[j].sectionId
            ) {
              state.choice.array[i].value = true;
              state.choice.array[i].correct = true;
            }
          }
        }
      }
      return state.choice.array.filter((f) => f.visibleType == 2);
    },
    getIndexCurrentStep(state) {
      let arrayRoute = state.choice.arrayRoute.filter(
          (f) => f.visibleType === 2
        ),
        currentLevel = state.general.currentLevel;

      // console.log('getIndexCurrentStep', currentLevel, arrayRoute);
      return arrayRoute.findIndex((f) => f.currentStep === currentLevel);
    },
    getFirstStepOrNot: (state) => state.general.firstStepOrNot,
    getGeneral: (state) => state.general,
    getChoice: (state) => state.choice,
    getComplaint: (state) => state.complaints,
    getAnamnes: (state) => state.anamnesis,
    getDataSomaticStatusBodySystems: (state) =>
      state.dataSomaticStatusBodySystems,
    getSprPhysResearch: (state) => state.sprPhysResearch,
    getDiagnosis: (state) => state.diagnosis,
    getRoute: (state) =>
      state.choice.arrayRoute.filter((f) => f.visibleType == 2),
    getLabTest: (state) => state.labTest,
    getInstrTest: (state) => state.instrTest,
    getShowContainers: (state) => state.showContainers,
  },
  mutations: {
    checkingFirstStep(state) {
      let route = state.choice.arrayRoute.filter((f) => f.visibleType == 2);

      if (route.length === 0) {
        return;
      }

      let currentStepIndex = null,
        firstIndexInObjWithArray = route[0].currentStep;

      for (let i = 0; i < route.length; i++) {
        if (route[i].view && !route[i].success) {
          currentStepIndex = route[i].currentStep;
          break;
        }
      }

      if (currentStepIndex < 0) {
        return;
      }
      state.general.firstStepOrNot =
        firstIndexInObjWithArray === currentStepIndex;
    },
    resetTimer(state) {
      state.general.timer = null;
    },
    addTimer(state, id) {
      state.general.timer = id;
    },
    changeCurrentStep(state, value) {
      state.general.currentLevel = value;
      // console.log('changeCurrentStep', state.general.currentLevel);
    },
    stopTimer(state) {
      clearInterval(state.general.timer);
    },
    saveInfoByTest(state, object) {
      state.general.info = object;
    },
    saveInfoByTestProperty(state, object) {
      state.general.virtualPatient = object;
    },
    saveSections(state, array) {
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < state.choice.arrayRoute.length; j++) {
          if (array[i].sectionId === state.choice.arrayRoute[j].sectionId) {
            state.choice.arrayRoute[j].visibleType = array[i].visibleType;
          }
        }
        for (let j = 0; j < state.choice.array.length; j++) {
          if (array[i].sectionId === state.choice.array[j].sectionId) {
            state.choice.array[j].load = false;
            state.choice.array[j].visibleType = array[i].visibleType;
          }
        }
      }
    },
    saveResultSection(state, obj) {
      for (let i = 0; i < state.choice.array.length; i++) {
        if (state.choice.array[i].sectionId === obj.answerSectionId) {
          state.choice.array[i].correct = obj.flag;
        }
      }
    },
    saveComplaints(state, array) {
      state.complaints.array = array;
    },
    changeFlagMedia(state, value) {
      state.sprPhysResearch.dialogMedia = value;

      if (!value) {
        state.sprPhysResearch.selectedCircle = {
          index: null,
          bodyPartId: null,
          files: [],
          name: '',
        };
      }
    },
    changeFlagShow(state, value) {
      state.showContainers = value;
    },
    saveAnamnesis(state, array) {
      state.anamnesis.array = array;
    },
    saveSprPhysResearch(state, obj) {
      if (!obj) return;
      state.sprPhysResearch.currentObj = obj;
    },
    saveSprBodySystem(state, array) {
      for (let i = 0; i < state.general.iconsList.length; i++) {
        for (let j = 0; j < array.length; j++) {
          if (state.general.iconsList[i].nameLong === array[j].name) {
            state.general.iconsList[i].id = array[j].id;
          }
        }
      }
    },
    saveDataSomaticStatusBodySystems(state, array) {
      for (let i = 0; i < state.general.iconsList.length; i++) {
        for (let j = 0; j < array.length; j++) {
          if (state.general.iconsList[i].id === array[j].bodySystemId) {
            state.general.iconsList[i].localStatus = array[j].localStatus;
          }
        }
      }

      state.dataSomaticStatusBodySystems = array;
    },
    saveDataSomaticStatuses(state, array) {
      state.sprPhysResearch.groups = [];

      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          let haveObject = state.sprPhysResearch.groups.findIndex(
            (f) => f.groupId == array[i].groupId
          );

          if (haveObject == -1) {
            state.sprPhysResearch.groups.push({
              groupId: array[i].groupId,
              groupName: array[i].groupName,
              groupSortOrder: array[i].groupSortOrder,
              indicators: [],
            });
          }

          for (let j = 0; j < state.sprPhysResearch.groups.length; j++) {
            if (state.sprPhysResearch.groups[j].groupId === array[i].groupId) {
              state.sprPhysResearch.groups[j].indicators.push(array[i]);
            }
          }
        }
        // console.log('state.sprPhysResearch.groups', state.sprPhysResearch.groups);
        return;
      }
      state.sprPhysResearch.groups = [];
      state.sprPhysResearch.object = null;
    },
    resetFiles(state) {
      state.sprPhysResearch.groups = [];

      for (let i = 0; i < state.sprPhysResearch.arrayCircles.length; i++) {
        state.sprPhysResearch.arrayCircles[i].files = [];
      }
    },
    resetArrayRoute(state) {
      for (let i = 0; i < state.choice.arrayRoute.length; i++) {
        state.choice.arrayRoute[i].view = false;
        state.choice.arrayRoute[i].success = false;
        state.choice.arrayRoute[i].visibleType = 1;
      }
    },
    resetChoice(state) {
      for (let i = 0; i < state.choice.array.length; i++) {
        state.choice.array[i].value = false;
        state.choice.array[i].correct = null;
      }
    },
    resetSprPhysResearchArray(state) {
      state.sprPhysResearch.groups = [];
    },
    saveFiles(state, array) {
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < state.sprPhysResearch.arrayCircles.length; j++) {
          if (
            array[i].bodyPartId ===
            state.sprPhysResearch.arrayCircles[j].bodyPartId
          ) {
            state.sprPhysResearch.arrayCircles[j].files = array[i].fileList;
          }
        }
      }
    },
    changeSelectedCircle(state, obj) {
      state.sprPhysResearch.selectedCircle = {
        index: obj.index,
        bodyPartId: obj.element.bodyPartId,
        files: obj.element.files,
        name: obj.element.name,
      };
    },
    saveMkbGuide(state, array) {
      for (let i = 0; i < array.length; i++) {
        array[i].nameCode = `${array[i].code} - ${array[i].name}`;
      }
      state.diagnosis.mkb = array;
    },
    saveSyndromDiagnoses(state, array) {
      state.diagnosis.mkb = array;
    },
    resetMkb(state) {
      state.diagnosis.mkb = [];
    },
    changeViewPage(state, name) {
      let arrayRoute = state.choice.arrayRoute.filter(
          (f) => f.visibleType == 2
        ),
        index = arrayRoute.findIndex((f) => f.name === name) + 1;

      if (index <= 0) {
        arrayRoute[index].view = true;
        return;
      }

      for (let i = 0; i < index; i++) {
        for (let j = 0; j < arrayRoute.length; j++) {
          if (i === j) {
            if (j > 0) arrayRoute[j - 1].success = true;
            arrayRoute[j].view = true;
          }
        }
      }
    },
    choiseSelected(state, currentStep) {
      let arrayRoute = state.choice.arrayRoute.filter(
          (f) => f.visibleType === 2
        ),
        index = arrayRoute.findIndex((f) => f.currentStep === currentStep);

      // console.log('choiseSelected', index, arrayRoute);
      if (index >= 1) {
        for (let i = 0; i < index; i++) {
          for (let j = 0; j < arrayRoute.length; j++) {
            if (i === j) {
              arrayRoute[j].view = true;
              arrayRoute[j].success = true;
            }
          }
        }

        return;
      }
    },
    saveLabResearchGroup(state, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].properties && array[i].properties.length > 0) {
          for (let j = 0; j < array[i].properties.length; j++) {
            array[i].properties[j].groupId = array[i].groupId;
          }
        }
      }
      state.labTest.group = array;
    },
    saveInstrResearchGroup(state, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].properties && array[i].properties.length > 0) {
          for (let j = 0; j < array[i].properties.length; j++) {
            array[i].properties[j].groupId = array[i].groupId;
          }
        }
      }
      state.instrTest.group = array;
    },
    savePatalogyForDiagnos(state, array) {
      function groupBy(array, key) {
        return array.reduce((total, current) => {
          let group = total.find((x) => x && x.key === current[key]);

          if (group) {
            group.values.push(current);
          } else {
            total.push({ key: current[key], values: [current] });
          }

          return total;
        }, []);
      }
      state.diagnosis.patalogy = groupBy(array, "pathologyGroupName");
    },
    deletePatalogy(state, obj) {
      for (let i = 0; i < state.diagnosis.patalogy.length; i++) {
        if (state.diagnosis.patalogy[i].key === obj.key) {
          state.diagnosis.patalogy[i].values.splice(obj.index, 1);

          // если удалили последнюю паталогию из группы, то группу тоже удалить надо
          if (state.diagnosis.patalogy[i].values.length === 0) {
            state.diagnosis.patalogy.splice(i, 1);
          }
          break;
        }
      }
    },
    openResearchLab(state, arrayOrObject) {
      if (typeof arrayOrObject === "object") {
        for (let i = 0; i < state.labTest.group.length; i++) {
          if (state.labTest.group[i].groupId === arrayOrObject.answerGroupId) {
            for (let j = 0; j < state.labTest.group[i].properties.length; j++) {
              if (
                state.labTest.group[i].properties[j].propertyId ===
                arrayOrObject.answerPropertyId
              ) {
                state.labTest.group[i].properties[j].isSelected = false;
              }
            }
          }
        }
      }
    },
    openResearchInstr(state, arrayOrObject) {
      if (typeof arrayOrObject === "object") {
        for (let i = 0; i < state.instrTest.group.length; i++) {
          if (
            state.instrTest.group[i].groupId === arrayOrObject.answerGroupId
          ) {
            for (
              let j = 0;
              j < state.instrTest.group[i].properties.length;
              j++
            ) {
              if (
                state.instrTest.group[i].properties[j].propertyId ===
                arrayOrObject.answerPropertyId
              ) {
                state.instrTest.group[i].properties[j].isSelected = false;
              }
            }
          }
        }
      }
    },
    resetDiagnosis(state) {
      state.diagnosis = {
        mkb: [],
        array: [],
        patalogy: [],
      };
    },
  },
  actions: {
    saveTime5s({ rootState }, idProcess) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${
              rootState.api
            }DiaTestProcess/AddTimeToDiaTestProcess?id=${idProcess}&seconds=${5}`,
            {}
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendSectionAnswer({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SendSectionAnswer?processId=${obj.processId}&answerSectionId=${obj.answerSectionId}`,
            {}
          )
          .then((res) => {
            commit("saveResultSection", {
              answerSectionId: obj.answerSectionId,
              flag: res.data,
            });
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setNextStepForDiaTestProcess({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SetNextStepForDiaTestProcess?id=${id}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendComplaintAnswer({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SendComplaintAnswer?processId=${obj.processId}&answerComplaintId=${obj.answerComplaintId}&isPathology=${obj.isPathology}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendAnamnesAnswer({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SendAnamnesAnswer?processId=${obj.processId}&answerAnamnesId=${obj.answerAnamnesId}&isPathology=${obj.isPathology}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendSomaticStatuseAnswer({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SendSomaticStatuseAnswer?processId=${obj.processId}&answerSomaticStatuseId=${obj.answerSomaticStatuseId}&isPathology=${obj.isPathology}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendDiagnoseAnswers({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SendDiagnoseAnswers?processId=${obj.processId}&diagnoseId=${obj.diagnoseId}&diagnoseType=${obj.diagnoseType}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendLabResearchPathologyAnswer({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SendLabResearchPathologyAnswer?processId=${obj.processId}&answerPropertyId=${obj.answerPropertyId}&isPathology=${obj.isPathology}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendInstrumentalResearchPathologyAnswer({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/SendInstrumentalResearchPathologyAnswer?processId=${obj.processId}&answerPropertyId=${obj.answerPropertyId}&isPathology=${obj.isPathology}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendVitalPathologyAnswer({ rootState }, obj) {
      axios
        .post(
          `${rootState.api}DiaTestProcess/SendVitalPathologyAnswer?processId=${obj.processId}&answerPropertyId=${obj.answerPropertyId}&isPathology=${obj.isPathology}`,
          {}
        )
        .then(() => {
          // console.log(res.data)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sendAnthropometricPathologyAnswer({ rootState }, obj) {
      axios
        .post(
          `${rootState.api}DiaTestProcess/SendAnthropometricPathologyAnswer?processId=${obj.processId}&answerPropertyId=${obj.answerPropertyId}&isPathology=${obj.isPathology}`,
          {}
        )
        .then(() => {
          // console.log(res.data)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addOrUpdateLabResearchAnswer({ rootState }, array) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/AddOrUpdateLabResearchAnswer`,
            array
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addOrUpdateInstrumentalResearchAnswer({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/AddOrUpdateInstrumentalResearchAnswer`,
            obj
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDiaTestProcessById({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}DiaTestProcess/GetDiaTestProcessById?id=${id}`)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSections({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetDiaTestSectionVisiblesByTestId?id=${id}`
          )
          .then((res) => {
            commit("saveSections", res.data);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setStepIsSelectedForDiaTestProcess({ rootState }, id) {
      axios.post(
        `${rootState.api}DiaTestProcess/SetStepIsSelectedForDiaTestProcess?id=${id}`,
        {}
      );
    },
    getComplaints({ commit, rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetComplaintsByTestId?processId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveComplaints", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAnamnesis({ commit, rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetAnamnesesByTestId?processId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveAnamnesis", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSprPhysResearch({ commit, rootState }, query) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.apiGuide}api/SprPhysResearch/GetAll?query=${query}`)
          .then((res) => {
            // console.log(res.data);3
            if (res.status === 200) {
              commit(
                "saveSprPhysResearch",
                res.data.length > 0 ? res.data[0] : null
              );
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMkb({ commit, rootState }, query) {
      axios
        .get(`${rootState.apiGuide}api/SprMkb10/GetAll?query=${query}`)
        .then((res) => {
          if (res.status === 200) {
            commit("saveMkbGuide", res.data);
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSyndromDiagnoses({ commit, rootState }) {
      axios
        .get(`${rootState.apiGuide}api/SprSyndromicDiagnose/GetAll`)
        .then((res) => {
          if (res.status === 200) {
            commit("saveSyndromDiagnoses", res.data);
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllSprBodySystem({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.apiGuide}api/SprBodySystem/GetAll`)
          .then((res) => {
            if (res.status === 200) {
              commit("saveSprBodySystem", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSomaticStatusBodySystems({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetSomaticStatusBodySystems?testId=${obj.testId}&physResearchId=${obj.physResearchId}&visibleOnly=true&systemsOnly=false`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveDataSomaticStatusBodySystems", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSomaticStatusesByTestId({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetSomaticStatusesByTestId?processId=${obj.processId}&bodySystemId=${obj.bodySystemId}&physResearchId=${obj.physResearchId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveDataSomaticStatuses", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMediaFilesByBodySystemId({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetMediaFilesByBodySystemId?testId=${obj.testId}&bodySystemId=${obj.bodySystemId}&type=${obj.type}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveFiles", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDiagnoseAnswers({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetDiagnoseAnswers?processId=${obj.processId}&diagnoseType=${obj.diagnoseType}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLabResearchesForProcess({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetLabResearchesForProcessByProcessId?processId=${obj.processId}&gender=${obj.gender}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveLabResearchGroup", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getInstrumentalResearchesForProcess({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetInstrumentalResearchesForProcessByProcessId?processId=${obj.processId}&gender=${obj.gender}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveInstrResearchGroup", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLabResearchAnswer({ commit, rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetLabResearchAnswer?processId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getInstrumentalResearchAnswer({ commit, rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetInstrumentalResearchAnswer?processId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getProcessPatologiesByDiagnoseType({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetProcessPatologiesByDiagnoseType?processId=${obj.processId}&diagnoseType=${obj.diagnoseType}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("savePatalogyForDiagnos", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getResultForResearch({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}${obj.url}?processId=${obj.processId}`)
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDiaTestProcessResult({ rootState }, resultId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetDiaTestProcessResult?resultId=${resultId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDiaTestProcess({ rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetDiaTestProcessResult?resultId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addOrUpdateDiaTestProcessResult({ rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTestProcess/AddOrUpdateDiaTestProcessResult?processId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getVitalPathologyAnswers({ rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetVitalPathologyAnswers?processId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAnthropometricPathologyAnswers({ rootState }, processId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTestProcess/GetAnthropometricPathologyAnswers?processId=${processId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deletePatalogyByDiagnos({ dispatch, commit }, obj) {
      return new Promise((resolve, reject) => {
        let guidePatalogy = {
          1: "sendComplaintAnswer",
          2: "sendAnamnesAnswer",
          3: "sendSomaticStatuseAnswer",
          4: "sendLabResearchPathologyAnswer",
          5: "sendInstrumentalResearchPathologyAnswer",
          6: "sendAnthropometricPathologyAnswer",
          7: "sendVitalPathologyAnswer",
        };

        dispatch(guidePatalogy[obj.pathologyType], {
          processId: obj.processId,
          answerComplaintId: obj.pathologyType === 1 ? obj.id : undefined,
          answerAnamnesId: obj.pathologyType === 2 ? obj.id : undefined,
          answerSomaticStatuseId: obj.pathologyType === 3 ? obj.id : undefined,
          answerPropertyId:
            obj.pathologyType === 4 ||
            obj.pathologyType === 5 ||
            obj.pathologyType === 6 ||
            obj.pathologyType === 7
              ? obj.id
              : undefined,
          isPathology: false,
        })
          .then((res) => {
            commit("deletePatalogy", { key: obj.key, index: obj.index });
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteDiagnosis({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${rootState.api}DiaTestProcess/DeleteDiagnoseAnswers?id=${id}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteLabResearchAnswer({ commit, rootState }, arrayOrObject) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${rootState.api}DiaTestProcess/DeleteLabResearchAnswer`, {
            data: Array.isArray(arrayOrObject)
              ? arrayOrObject
              : [arrayOrObject.id],
          })
          .then((res) => {
            if (res.status === 200) {
              if (!Array.isArray(arrayOrObject))
                commit("openResearchLab", arrayOrObject);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteInstrumentalResearchAnswer({ commit, rootState }, arrayOrObject) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${rootState.api}DiaTestProcess/DeleteInstrumentalResearchAnswer`,
            {
              data: Array.isArray(arrayOrObject)
                ? arrayOrObject
                : [arrayOrObject.id],
            }
          )
          .then((res) => {
            if (res.status === 200) {
              if (!Array.isArray(arrayOrObject))
                commit("openResearchInstr", arrayOrObject);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    diaTestGet({ commit, rootState }, id) {
      axios
        .get(`${rootState.api}DiaTest/Get?id=${id}`)
        .then((res) => {
          if (res.status === 200) {
            commit("saveInfoByTest", res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getVirtualInformation({ commit, rootState }, id) {
      axios
        .get(`${rootState.api}DiaTest/GetTestPropertyByTestId?id=${id}`)
        .then((res) => {
          if (res.status === 200) {
            commit("saveInfoByTestProperty", res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    saveResultTest({ rootState }, obj) {
      console.log(obj);
      // return new Promise((resolve, reject) => {
      // 	axios.post(`${rootState.api}DiaTestProcess/ssssssssssss?processId=${obj.processId}&answerPropertyId=${obj.answerPropertyId}&isPathology=${obj.isPathology}`, {})
      // 	.then((res) => {
      // 		resolve(res.data)
      // 	})
      // 	.catch(err => {
      // 		reject(err)
      // 	})
      // })
    },
    getMediaForInstrumental({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetMediaFilesByPropertyId?testId=${obj.testId}&sectionId=${obj.sectionId}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
